<template>
  <header>
    <template v-if="title === 'editStory'">
      <p class="title elli">{{getStoryTitle()}}</p>
    </template>
    <template v-else>
      <p class="title elli">{{title}}</p>
    </template>
    <a v-if="closeModule" href="javascript:;" class="go-back" @click="close">
      <i class="back-ico"></i>
      <span class="back-note">{{backNote}}</span>
    </a>
    <img v-if="isStoryMenu" src="../../static/image/header_menu.png" :alt="configText.menu" class="menu"
         @click="showMenu">
  </header>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import configText from '../config/ConfigText';
  import {ComponentName, Methods} from '../const/common';
  import {ProjectData} from '../store/ProjectData';

  export default {
    name: 'header',
    data() {
      return {
        projectData: new ProjectData(this),
        configText: configText
      }
    },
    computed: {
      ...mapState(['moduleState'])
    },
    props: {
      title: {
        type: String
      },
      isStoryMenu: {
        type: Boolean
      },
      backPage: {
        type: String
      },
      backNote: {
        type: String
      },
      closeModule: {
        type: String
      }
    },
    store,
    methods: {
      getStoryTitle() {
        let _store = store.state;

        if (_store.chapterList.length > 0) {
          return _store.storyName + ':' + _store.chapterList[_store.editChapter === '' ? 0 : _store.editChapter].name;
        }
      },
      showMenu() {
        Methods.cutComponent([ComponentName.STORY_MENU], true);
        Methods.checkChapterHash(8);
      },
      closeAll(sign) {
        Methods.cutComponent('all', false);
        if (sign) {
          Middle.projectData = null;
          store.state.useRole = {charId: -1, cover: null, name: "", mood: 'normal'};
          store.state.editMsgText = '';
          store.state.storyCover = null;
          Methods.cutComponent([ComponentName.STORYS_LIST], true);
          store.state.editText = false;
          store.state.setRoleSiteDom = false;
          return;
        }
        // if (this.$props.backPage === ComponentName.EDIT_STORY) {
        //   Methods.setRoleSite();
        // }
        Methods.cutComponent([this.$props.backPage], true);
      },
      setRunning(b) {
        egret.setRunning(b);
      },
      saveRemind(isSetStatus) {
        Methods.messageConfirm('', '退出时工程将自动保存，<br>是否确定？', '是', '否', function () {
          if (isSetStatus) {
            Middle.MiddleData.SetStatus(1);
          }
          this.projectData.saveStory(null, null);
          store.state.sendMesCount = 0;
          Methods.exitEditor();
          this.closeAll(true);
        }.bind(this), null);
      },
      close() {
        Methods.multimediaReset();
        if (this.$props.backPage === '') {
          Methods.cutComponent([this.$props.closeModule], false);
        } else if (this.$props.closeModule === ComponentName.ROLE_LIST) {
          store.state.watchHasMainRole = true;
        } else if (this.$props.closeModule === ComponentName.EDIT_STORY_ROLE) {
          this.saveRemind(true);
        } else if (this.$props.closeModule === ComponentName.EDIT_STORY) {
          store.state.closeEditStory = true;
          this.saveRemind(false);
        } else {
          if (this.$props.closeModule === ComponentName.EDIT_STORY_TEXT && store.state.guideConf.isShow) {
            return false;
          }
          this.closeAll(false);
          if (this.$props.closeModule === ComponentName.CHAPTER_SET) {
            store.commit('editStorySetout');
            Methods.clearStageRoleSign();
          }
          if (this.$props.closeModule === ComponentName.CREATE_ROLE) {
            store.commit('initStateCreateRole');
          }
        }
        Methods.checkChapterHash(3);
      }
    }
  }
</script>

<style scoped>
  @import "../style/base/header.css";
</style>



// WEBPACK FOOTER //
// src/components/header.vue